.biel-terms-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: var(--biel-bot-content-font-family);
  color: var(--biel-terms-modal-color);
}

.biel-terms-modal-content {
  background-color: var(--biel-terms-modal-bg-color);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 600px;
  width: 90%;
  position: relative;
}

.biel-terms-modal-title {
  font-weight: bold;
  margin-top: 10px;
}

.biel-terms-modal-text {
  margin-bottom: 10px;
}

.biel-terms-modal-text a {
  color: var(--biel-terms-modal-link-color);
  text-decoration: none;
}

.biel-terms-modal-text a:hover {
  text-decoration: underline;
}

.checkbox-container input {
  transform: scale(1.2);
}

.checkbox-container {
  margin: 15px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn {
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-family: var(--biel-bot-content-font-family);
}

.decline-btn {
  background-color: var(--biel-white-hover-color);
  color: var(--biel-terms-modal-decline-btn-color);
}

.decline-btn:hover {
  background-color: var(--biel-terms-modal-decline-btn-hover-bg-color);
}

.accept-btn {
  background-color: var(--biel-terms-modal-accept-btn-bg-color);
  color: var(--biel-terms-modal-accept-btn-color);
}

.accept-btn:disabled {
  background-color: var(--biel-terms-modal-accept-btn-bg-color-disabled);
  color: var(--biel-terms-modal-accept-btn-color-disabled);
  cursor: not-allowed;
}

.accept-btn:hover:enabled {
  background-color: var(--biel-terms-modal-accept-btn-bg-color-hover);
}

.button-container {
  display: flex;
  margin-top: 15px;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--biel-terms-modal-close-btn-color);
  cursor: pointer;
}

.close-btn:hover {
  color: var(--biel-terms-modal-close-btn-color-hover);
}
